import React from 'react';
import { FileInput, MessageSquare, Download, Save, Trash2 } from 'lucide-react';

interface ActionBarProps {
  onInsert: (text: string) => void;
  onAddComment: (text: string) => void;
  onExport: () => void;
  onClear: () => void;
  disabled: boolean;
  hasMessages: boolean;
}

export const ActionBar: React.FC<ActionBarProps> = ({
  onInsert,
  onAddComment,
  onExport,
  onClear,
  disabled,
  hasMessages
}) => {
  return (
    <div className="bg-white dark:bg-dark-surface border-t border-gray-200 dark:border-dark-border px-6 py-3 flex items-center gap-3">
      <button
        onClick={() => onInsert('')}
        disabled={disabled}
        className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        title="Insert the AI response into the contract"
      >
        <FileInput className="w-4 h-4" />
        <span className="hidden sm:inline">Insert to Contract</span>
        <span className="sm:hidden">Insert</span>
      </button>

      <button
        onClick={() => onAddComment('')}
        disabled={disabled}
        className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        title="Add the AI response as a comment"
      >
        <MessageSquare className="w-4 h-4" />
        <span className="hidden sm:inline">Add as Comment</span>
        <span className="sm:hidden">Comment</span>
      </button>

      <button
        onClick={onExport}
        disabled={!hasMessages}
        className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        title="Export conversation"
      >
        <Download className="w-4 h-4" />
        <span className="hidden sm:inline">Export</span>
      </button>

      <div className="flex-1" />

      {hasMessages && (
        <button
          onClick={onClear}
          className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-red-600 dark:text-red-400 bg-white dark:bg-gray-800 border border-red-200 dark:border-red-800 rounded-lg hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors"
          title="Clear conversation"
        >
          <Trash2 className="w-4 h-4" />
          <span className="hidden sm:inline">Clear Chat</span>
        </button>
      )}

      <button
        disabled={disabled}
        className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-primary-600 rounded-lg hover:bg-primary-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        title="Save current draft"
      >
        <Save className="w-4 h-4" />
        <span className="hidden sm:inline">Save Draft</span>
        <span className="sm:hidden">Save</span>
      </button>
    </div>
  );
};

export default ActionBar;
